import AffluenzaRegCamera from '@/data/affluenza_regioni_camera.json';
import AffluenzaRegSenato from '@/data/affluenza_regioni_senato.json';
import { StructureType } from './model';

export const getAffluenzaCameraNazionaleEleT = (
  type = StructureType.CAMERA
) => {
  let list =
    type === StructureType.CAMERA ? AffluenzaRegCamera : AffluenzaRegSenato;
  return list.enti.ente_p.ele_t || 0;
};

export const getAffluenzaCameraNazionalePerc = (
  type = StructureType.CAMERA
) => {
  let list =
    type === StructureType.CAMERA ? AffluenzaRegCamera : AffluenzaRegSenato;
  let indexCom = type === StructureType.CAMERA ? 2 : 0;
  return list.enti.ente_p.com_vot[indexCom]?.perc || '0';
};

export const getAffluenzaCameraNazionaleVoti = (
  type = StructureType.CAMERA
) => {
  let list =
    type === StructureType.CAMERA ? AffluenzaRegCamera : AffluenzaRegSenato;
  let indexCom = type === StructureType.CAMERA ? 2 : 0;
  return list.enti.ente_p.com_vot[indexCom]?.vot_t || 0;
};

export const getAffluenzaCameraRegionePerc = (
  cod_reg: number,
  type = StructureType.CAMERA
) => {
  return getAffluenzaCameraRegione(cod_reg, type)?.perc || '0';
};

export const getAffluenzaCameraRegioneVoti = (
  cod_reg: number,
  type = StructureType.CAMERA
) => {
  return getAffluenzaCameraRegione(cod_reg, type)?.vot_t || 0;
};

export const getAffluenzaCameraRegione = (
  cod_reg: number,
  type = StructureType.CAMERA
) => {
  let list =
    type === StructureType.CAMERA ? AffluenzaRegCamera : AffluenzaRegSenato;
  let indexCom = type === StructureType.CAMERA ? 2 : 0;
  if (isNaN(cod_reg)) {
    cod_reg = 2; // VDA
  }
  return list.enti.enti_f.find(r => r.cod === cod_reg)?.com_vot[indexCom];
};

export const getAffluenzaCameraRegioneEleT = (
  cod_reg: number,
  type = StructureType.CAMERA
) => {
  let list =
    type === StructureType.CAMERA ? AffluenzaRegCamera : AffluenzaRegSenato;
  if (isNaN(cod_reg)) {
    cod_reg = 2; // VDA
  }
  return list.enti.enti_f.find(r => r.cod === cod_reg)?.ele_t || 0;
};
